import { Box } from '@mui/material';
import React from 'react';
import { useController } from 'react-hook-form';

import FormFields from '../FormFields';
import { InputRenderer } from '../types';

import { DESTROY_FIELD } from './AssociationInput/NestedFormFields';

const DESTROYED_OPACITY = 0.5;

const AssociationInput = ({
  index,
  inputProps: { name, value },
  multiple,
  nestedFields,
  storageKey,
}: InputRenderer) => {
  const prefix = typeof index === 'number' ? `${name}.${index}` : name;
  const {
    field: { value: isDestroyed },
  } = useController({ name: `${prefix}.${DESTROY_FIELD}` });
  const persisted = !!value['id'];

  if (isDestroyed && !persisted) {
    return null;
  }

  return (
    <Box
      component="fieldset"
      sx={{
        border: '1px',
        borderColor: 'gray.200',
        borderRadius: 'base',
        marginBottom: '1em',
        flexGrow: 1,
        padding: multiple ? '1em' : undefined,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5em',
          width: '100%',
          opacity: isDestroyed ? DESTROYED_OPACITY : 1,
        }}
      >
        <FormFields fields={nestedFields ?? []} prefix={prefix} storageKey={storageKey} />
      </Box>
    </Box>
  );
};

export default AssociationInput;
